import * as React from "react";

import "./select-editions-layout.scss";

export const SelectEditionsLayout = ({topControl, content}) => (
    <div className="select-editions-layout-962">

        <div className="header">
            <div className="left">
                <div {...{
                    className: "title",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Preferences",
                }}>
                    Preferences
                </div>
                <div {...{
                    className: "subtitle",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Preferences Description",
                }}>
                    Each Edition will be mailed/shipped within 5 business days after the Final Day to Edit period.
                </div>
            </div>
            <div className="right">
                {topControl}
            </div>
        </div>

        <div className="box">
            {content}
        </div>

    </div>
);

